// extracted by mini-css-extract-plugin
export default {"textField":"TextField_textField__kchW4","text":"TextField_text__G8i0t","alightRight":"TextField_alightRight__SxD7R"};